<section
  id="form_page"
  class="container loading_container"
  [ngClass]="{ loaded: passCultureForm }"
>
  <div *ngIf="loaded" class="loading_content">
    <div id="page_header">
      <h1>Pass Culture</h1>
      <app-button
        (clickEvent)="goBack()"
        text="retour"
        [style]="'border blue'"
      ></app-button>
    </div>
    <div id="form_wrapper">
      <!-- Non-admin: événement NON synchronisé -->
      <div *ngIf="!isAdmin && !event?.passCultureSettings?.isEnabled" class="passculture-info">
        <h2>Pass Culture</h2>
        <div class="info-block">
          <h4>Qu'est-ce que le Pass Culture ?</h4>
          <p>Le Pass Culture est une initiative visant à promouvoir l'accès à la culture pour les jeunes en France en leur offrant une somme d'argent à dépenser pour des activités culturelles comme des places de concerts ou encore des festivals.</p>

          <h4>Pourquoi activer le Pass Culture ?</h4>
          <p>Activer l'intégration Pass Culture vous permet d'intégrer automatiquement les billets générés sur Pass Culture à votre contrôle d'accès sans passer par un import manuel.</p>

          <p>Vous souhaitez synchroniser votre événement avec le Pass Culture ? Contactez-nous pour activer cette fonctionnalité.</p>

          <div class="info-actions">
            <a [href]="'mailto:billetterie@oandb.eu?subject=Activation Pass Culture&body=Événement : ' + event?.name + '%0AOrganisation : ' + organisation?.name" class="btn plain">Nous contacter</a>
          </div>
        </div>
      </div>

      <!-- Non-admin: événement synchronisé -->
      <div *ngIf="!isAdmin && event?.passCultureSettings?.isEnabled" class="passculture-info">
        <h2>Pass Culture</h2>
        <div class="info-block success">
          <h4>Votre événement est synchronisé avec le Pass Culture</h4>
          <p>L'intégration Pass Culture est active pour cet événement. Les billets générés via Pass Culture seront automatiquement intégrés à votre contrôle d'accès.</p>
          <p>Pour toute modification de la configuration Pass Culture, veuillez contacter notre équipe.</p>

          <div class="info-actions">
            <a *ngIf="eventOffer?.id" [href]="passCultureUrl + '/offre/' + eventOffer.id" target="_blank" class="btn plain">Voir sur Pass Culture</a>
            <a [href]="'mailto:billetterie@oandb.eu?subject=Modification Pass Culture&body=Événement : ' + event?.name + '%0AOrganisation : ' + organisation?.name" class="btn outline">Nous contacter</a>
          </div>
        </div>
      </div>

      <!-- Admin: formulaire complet -->
      <h2 *ngIf="isAdmin">Créer une offre Pass Culture</h2>
      <form *ngIf="isAdmin && passCultureForm && venueEnabled === true" [formGroup]="passCultureForm">
        <div class="form_cols">
          <input id="isEnabled" type="checkbox" formControlName="isEnabled" />
          <label for="isEnabled">
            Activer le Pass Culture
            <svg role="img" title="check" class="check-icon">
              <use href="assets/images/sprite.svg#icon-check"></use>
            </svg>
          </label>
        </div>
        <div *ngIf="passCultureForm.get('isEnabled').value" class="form_ctn">

        <div class="title_group">
          <h4>Visuel</h4>
          <p>Ajoutez une image de présentation de votre offre Pass Culture (format 500x760px).</p>
        </div>

        <app-file-input #fileInput *ngIf="loaded"
            disabledText="Visuel non modifiable"
             class="form_item"
             [loading]="loadingImage"
            [imageWidth]="200"
            text="Ajouter l'image de présentation de votre offre Pass Culture"
            [preFile]="currentImage"
            (imageChange)="changeImage($event)"
            [maintainAspectRatio]="true"
            [aspectRatio]="25/38"
            [cropperMinWidth]="250"
            [cropperMinHeight]="380"
            [resizeToWidth]="500"
            [resizeToHeight]="760">
        </app-file-input>

        <div class="title_group">
          <h4>Tarifs disponibles</h4>
          <p>Choisissez les tarifs disponibles pour votre offre Pass Culture :</p>
        </div>

          <div class="form_item" *ngIf="ticketTypes?.length">
              <div class="input_wrap select multiple">
                <span class="select_multiple_toggle" (click)="dropDown = !dropDown; $event.stopPropagation()">
                  {{getTicketsName()}}
                </span>
                <svg role="img" title="chevron" class="icon-chevron">
                  <use href="assets/images/sprite.svg#icon-chevron"></use>
                </svg>
                <div class="dropdown multiple" *ngIf="dropDown" (click)="$event.stopPropagation()">
                  <ul>
                    <li *ngFor="let ticket of ticketTypes; let i = index">
                      <input id="ticket_{{i}}" type="checkbox" [attr.checked]="ticketChecked(ticket._id)"
                        (change)="checkTicket(ticket._id, $event.target.checked)" />
                      <label for="ticket_{{i}}">
                        {{ticket.name}} <span class="ticket_category"> - {{ticket.ticketTypeCategoryId?.name || 'Sans
                          catégorie'}}</span>
                        <svg role="img" title="check" class="check-icon">
                          <use href="assets/images/sprite.svg#icon-check"></use>
                        </svg>
                      </label>
                    </li>
                  </ul>
                  <div class="dropdown_action">
                    <app-button (clickEvent)="dropDown = false" text="Sélectionner" [style]="'plain full'"></app-button>
                  </div>
                </div>
              </div>
            </div>

            <div class="form_item">
              <label for="bookingContact">Email de contact *</label>
              <input id="bookingContact" type="email" formControlName="bookingContact" />
              <p class="form_info">Email à contacter en cas de problème avec la réservation de l'offre</p>
            </div>

            <div class="form_item">
              <input id="enableDoubleBookings" type="checkbox" formControlName="enableDoubleBookings" />
              <label for="enableDoubleBookings">
                Activer les réservations "duo"
                <svg role="img" title="check" class="check-icon">
                  <use href="assets/images/sprite.svg#icon-check"></use>
                </svg>
              </label>
            </div>

        <div class="form_item">
            <label for="category-time">Catégorie (ne peux pas être modifiée si l'offre est active)</label>
            <div class="input_wrap select">
              <select [attr.disabled]="eventOffer?.status === 'ACTIVE' ? true : null" id="booking-time" formControlName="category">
                <option
                  *ngFor="let availableCategory of availableCategories"
                  [ngValue]="availableCategory"
                >
                  {{ availableCategory }}
                </option>
              </select>
              <svg role="img" title="chevron" class="icon-chevron">
                <use href="assets/images/sprite.svg#icon-chevron"></use>
              </svg>
            </div>
          </div>

        <div *ngIf="showSubCategory('showType')" class="form_item">
            <label for="showType">Type de spectacle</label>
            <div class="input_wrap select">
              <select id="showType" formControlName="showType">
                <option
                  *ngFor="let availableShowType of availableShowTypes"
                  [ngValue]="availableShowType"
                >
                  {{ availableShowType }}
                </option>
              </select>
              <svg role="img" title="chevron" class="icon-chevron">
                <use href="assets/images/sprite.svg#icon-chevron"></use>
              </svg>
            </div>
          </div>

          <div *ngIf="showSubCategory('musicType')" class="form_item">
            <label for="musicType">Type de musique</label>
            <div class="input_wrap select">
              <select id="musicType" formControlName="musicType">
                <option
                  *ngFor="let availableMusicType of availableMusicTypes"
                  [ngValue]="availableMusicType"
                >
                  {{ availableMusicType }}
                </option>
              </select>
              <svg role="img" title="chevron" class="icon-chevron">
                <use href="assets/images/sprite.svg#icon-chevron"></use>
              </svg>
            </div>
          </div>

          <div *ngIf="showSubCategory('author')" class="form_item">
            <label for="author">Auteur</label>
            <input id="author" type="text" formControlName="author" />
          </div>

          <div *ngIf="showSubCategory('performer')" class="form_item">
                      <label for="performer">Interprète</label>
            <input id="performer" type="text" formControlName="performer" />
          </div>

          <div *ngIf="showSubCategory('stageDirector')" class="form_item">
                      <label for="stageDirector">Metteur en scène</label>

            <input id="stageDirector" type="text" formControlName="stageDirector" />
          </div>

          <div *ngIf="showSubCategory('speaker')" class="form_item">
            <label for="speaker">Intervenant</label>
            <input id="speaker" type="text" formControlName="speaker" />
          </div>

          <div *ngIf="showSubCategory('visa')" class="form_item">
            <label for="visa">Visa</label>
            <input id="visa" type="text" formControlName="visa" />
          </div>

        <div id="accessibility" formGroupName="accessibility">

        <div class="title_group">
          <h4>Modalités d’accessibilité</h4>
          <p>Cette offre est accessible au public en situation de handicap :</p>
        </div>
          <div class="form_item">
              <input id="audioDisabilityCompliant" type="checkbox" formControlName="audioDisabilityCompliant" />
              <label for="audioDisabilityCompliant">
                Auditif
                <svg role="img" title="check" class="check-icon">
                  <use href="assets/images/sprite.svg#icon-check"></use>
                </svg>
              </label>
            </div>

          <div class="form_item">
              <input id="mentalDisabilityCompliant" type="checkbox" formControlName="mentalDisabilityCompliant" />
              <label for="mentalDisabilityCompliant">
                Psychique ou cognitif
                <svg role="img" title="check" class="check-icon">
                  <use href="assets/images/sprite.svg#icon-check"></use>
                </svg>
              </label>
            </div>

          <div class="form_item">
            <input id="motorDisabilityCompliant" type="checkbox" formControlName="motorDisabilityCompliant" />
            <label for="motorDisabilityCompliant">
              Moteur
              <svg role="img" title="check" class="check-icon">
                <use href="assets/images/sprite.svg#icon-check"></use>
              </svg>
            </label>
          </div>

          <div class="form_item">
            <input id="visualDisabilityCompliant" type="checkbox" formControlName="visualDisabilityCompliant" />
            <label for="visualDisabilityCompliant">
              Visuel
              <svg role="img" title="check" class="check-icon">
                <use href="assets/images/sprite.svg#icon-check"></use>
              </svg>
            </label>
          </div>

          </div>



     </div>
     <div class="form_actions right">
          <app-button
            [loadingOff]="loadingState$"
            [style]="'plain'"
            type="submit"
            [disabled]="passCultureForm.invalid || !newImage"
            (clickEvent)="updatePassCultureConfig()"
            text="Synchroniser mon événement"
          >
          </app-button>
        </div>
      </form>

      <div *ngIf="isAdmin && venueEnabled === false" class="helptext">

        <h4>Configuration requise.</h4>
        <p>Afin de pouvoir synchroniser votre événement avec Pass Culture, vous devez effectuer les étapes suivantes :</p>
        <ol>
						<li *ngIf="!siret">
							Renseignez votre numéro de SIRET dans votre espace organisateur OandB. Il doit être identique à celui créé sur le site Pass Culture.
						</li>
            <li *ngIf="siret">
              Veillez à ce que votre numéro de SIRET renseigné dans votre espace organisateur OandB soit identique à celui créé sur le site Pass Culture. <strong>{{siret}}</strong>
            </li>
						<li>Créez ou configurez votre compte sur le site Pass Culture.</li>
						<li>
							Une fois votre espace culturel activé, dans "paramètres généraux", sélectionnez "OandB" dans la liste des logiciels tiers.
						</li>
						<li>
							Une fois ces étapes effectuées, revenez sur cette page pour activer le Pass Culture sur votre événement.
						</li>
					</ol>
      </div>

    </div>
  </div>
</section>